import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { ItemList } from "./ItemList";
import Seo from "./Head";
import { CartContext } from "../context/CartContext";
import Player from "react-player";

const ItemListContainer = () => {
  window.scrollTo(0, 0);
  const { nombreCategoria } = useParams();

  // 1. CAMBIO: Traemos activeItems en lugar de items
  const { activeItems, isLoading } = useContext(CartContext);

  // 2. CAMBIO: Filtramos sobre la lista de activos
  const productosCategoria =
    nombreCategoria !== "todos"
      ? activeItems.filter((p) => p.categoria === nombreCategoria)
      : activeItems;

  const urlParts = window.location.pathname.split("/");
  const lastUrlPart = urlParts[urlParts.length - 1];

  // Opcional: Podrías retornar un Loader si isLoading es true
  // if (isLoading) return <Loader />;

  return (
    <>
      <Seo
        title={"Catálogo"}
        description={"Recetados, Sol, Contactología"}
        image={`${window.location.origin}/logoVioleta.jpg`}
        pathSlug={window.location.href}
      />

      <div className="item row">
        {/* VIDEO IRROMPIBLE */}
        <div
          className={`col-6 col-md-3 card ${
            lastUrlPart !== "irrompible" ? "d-none" : ""
          }`}
        >
          <Player
            url="http://drive.google.com/uc?export=view&id=1ozbuQd-R4vVVPJINLkcc2QDfy7_UmsMb"
            muted={true}
            playing={true}
            loop={true}
            width={"100%"} // Ajustado para mejor respuesta
            height={"auto"}
            title="irrompible"
          />
        </div>

        {/* VIDEO SOL */}
        <div
          className={`col-6 col-md-3 card ${
            lastUrlPart !== "sol" ? "d-none" : ""
          }`}
        >
          <Player
            url="http://drive.google.com/uc?export=view&id=1Nh1wA7camS_h6_TxBJrBPPvOG4pUW5Xt"
            muted={true}
            playing={true}
            loop={true}
            width={"100%"}
            height={"auto"}
            title="sol"
          />
        </div>

        {/* PASAMOS LA LISTA YA FILTRADA POR ESTADO Y CATEGORÍA */}
        <ItemList items={productosCategoria} />
      </div>
    </>
  );
};

export default ItemListContainer;
